import { QueryStringBuilderFactoryModule } from '@b2c/common/factories/QueryStringBuilder/QueryStringBuilder.factory';
import { scrubMembership, VerifiedMemberInfo } from '@b2c/types/membership';
import { TODO } from '@b2c/types/utils';
import angular, { IHttpParamSerializer, ILogService, IRootScopeService } from 'angular';
import uiRouter, { StateService, TransitionService } from 'angular-ui-router';
import _ from 'lodash';
import { BugsnagService, BugsnagServiceModule } from '../bugsnag';
import { LocalStorageService, LocalStorageServiceModule } from '../storage';

export class HelpersService {
  static $inject = ['QueryStringBuilderFactory', '$httpParamSerializerJQLike'];

  errors: TODO[] = [];
  dateFormats = {
    tinyDate: 'M/d',
    shortDate: 'M/d/yy',
    shortDateTime: "M/d/yy 'at' h:mm a",
    standardDate: 'MMM d, yyyy',
    shortStandardDate: 'MMM d',
    standardTime: 'h:mm a',
    militaryTime: 'HH:mm',
    standardDateTime: "MMM d, yyyy 'at' h:mm a",
    mediumDate: 'EEEE, MMMM d',
    extendedDate: 'EEEE, MMMM d, yyyy',
    extendedDateTime: "EEEE, MMMM d, yyyy 'at' h:mm a",
    fullMoYrDate: 'MMMM d, yyyy',
    sortDate: 'yyyy-M-d',
    sortDateTime: "yyyy-M-d 'at' h:mm a",
    fieldDate: 'yyyy-MM-dd',
    standardExpireDate: 'MMM yyyy',
    ccExpirationDate: 'mmYY',
    longYear: 'yyyy',
    shortYear: "'yy",
    month: 'MMMM yyyy',
    day: 'dddd, MMM d, yyyy',
    fullCalendarTime: 'h:mmtt',
    week: "'MMM d[ yyyy]{ '&#8212;'[ MMM] d yyyy}'",
    ISO8601: 'yyyy-MM-ddTHH:mm:ssZ',
  };

  constructor(private QueryStringBuilderFactory: TODO, private $httpParamSerializerJQLike: IHttpParamSerializer) {}

  init() {
    return true;
  }

  /**
   * Extends an object
   */
  decorate(a: TODO, b: TODO) {
    $.extend(a, b);
  }

  /**
   * Convert string or number to an integer value
   */
  currencyFloatToInteger(value: string | number, significant?: number) {
    let r = 0;
    let digit = 0;
    const sigs = significant ? significant : 2;
    let decimal = 0;

    if (typeof value === 'string') {
      r = parseFloat(value);
    } else if (typeof value === 'number') {
      r = value;
    }

    if (isNaN(r)) {
      r = 0;
    } else {
      decimal = r * Math.pow(10, sigs);
      r = parseInt(String(decimal), 10);
      const round = decimal.toString().split('.')[1];
      if (round) {
        digit = parseInt(round.charAt(0), 10);
        if (parseInt(String(digit), 10) >= 5) {
          r += 1;
        }
      }
    }

    return r;
  }

  /**
   * Convert string or number to an integer value with significant digits
   */
  integerToCurrencyFloat(value: number, significant?: number) {
    let r = 0;
    let digit = 0;
    const sigs = significant ? significant : 2;
    let decimal = 0;

    if (typeof value === 'number') {
      r = value;
    }

    if (isNaN(r)) {
      r = 0;
    } else {
      decimal = r / Math.pow(10, sigs);
      r = decimal;
      const round = decimal.toString().split('.')[1];
      if (round && round.length > 2) {
        digit = parseInt(round.charAt(2), 10);
        if (parseInt(String(digit), 10) >= 5) {
          r += 1;
        }
      }
    }

    return r;
  }

  /**
   * Capitalize
   */
  cap(value: string) {
    return value ? value.charAt(0).toUpperCase() + value.slice(1) : '';
  }

  /**
   * lowCapitalize
   */
  low(value: string) {
    return value ? value.charAt(0).toLowerCase() + value.slice(1) : '';
  }

  /**
   * Merges two arrays uniquely
   */
  unique<T = any>(a: Array<T>, b: Array<T>) {
    let _a: TODO[] = [];
    let _b: TODO[] = [];

    if (a) {
      if (!(a instanceof Array)) {
        _a = [a];
      } else if (a instanceof Array) {
        _a = a;
      }
    }

    if (b) {
      if (!(b instanceof Array)) {
        _b = [b];
      } else if (b instanceof Array) {
        _b = b;
      }
    }

    for (let i = 0, ii = _b.length; i < ii; i++) {
      if (_a.indexOf(_b[i]) === -1) {
        _a.push(_b[i]);
      }
    }

    console.log('HelpersService::unique', _a, _b);
    return _a;
  }

  /**
   * Converts a date to string
   */
  getEth(date: TODO) {
    let suffix = '';
    const s = date.toString();
    const numDate = parseInt(date, 10);
    const num = parseInt(s.substr(-1), 10);

    switch (num) {
      case 1:
        suffix = 'st';
        break;
      case 2:
        suffix = 'nd';
        break;
      case 3:
        suffix = 'rd';
        break;
      default:
        suffix = 'th';
    }

    if (numDate === 11 || numDate === 12 || numDate === 13) {
      suffix = 'th';
    }

    return s + suffix;
  }

  parametrize(o: TODO) {
    const query: TODO[] = [];

    for (const prop in o) {
      query.push(prop + '=' + o[prop]);
    }

    return '?' + query.join('&');
  }

  parseQueryString(queryString: string, match?: unknown) {
    let result: TODO | false = false;
    const a = document.createElement('a');

    if (typeof queryString === 'string') {
      a.href = queryString;
      const query = a.search && a.search.indexOf('?') === 0 ? a.search.split('?')[1] : false;
      if (query) {
        console.log(query);
        const params = query.split('&');
        console.log(params);

        if (params.length) {
          result = {};
        }

        for (let i = 0, ii = params.length; i < ii; i++) {
          const param = params[i].split('=');
          result[param[0]] = param[1] || '';
          if (match) {
            result = false;
            if (match === param[0]) {
              result = {};
              result[param[0]] = param[1] || '';
              break;
            }
          }
        }
      }
    }

    return result;
  }

  /**
   * Strip HTML from text
   */
  strip(text: string, limit: number) {
    let r = String(text).replace(/<[^>]+>|(?!<br>)(?!&nbsp;)(?!&amp;)&.*?;/gm, '');

    r = r.replace(/<br>/gm, ' ');
    r = r.replace(/&amp;/gm, '&');
    r = r.replace(/&nbsp;/gm, ' ');

    if (limit && r.length > limit) {
      r = r.substring(0, limit - 2) + '...';
    }

    console.log('HelpersService::strip', r, limit, r.length);
    return r;
  }

  /**
   * Convert new lines to breaks
   */
  convertBreaks(text: string) {
    let r = text;

    if (text) {
      r = text.replace(/\n/g, '<br />');
      console.log('Review::convertBreaks', r, text, r.match(/\n/g));
    }

    return r;
  }

  getPrimaryImage(item, useAlternate) {
    let r = '';

    if (item.hasOwnProperty('images') && item.images instanceof Array && item.images.length > 0) {
      for (let i = 0, ii = item.images.length; i < ii; i++) {
        if (item.images[i].primary) {
          r = item.images[i];
          break;
        }
      }

      if (!r && useAlternate) {
        r = item.images[0] || '';
      }
    }

    return r;
  }

  /**
   * Converts months into years/months readable string
   */
  getFormattedDuration(durationInMonths: TODO) {
    let r = '';
    let years = 0;
    let months = 0;

    if (durationInMonths && !isNaN(parseInt(durationInMonths, 10))) {
      if (durationInMonths >= 12) {
        years = parseInt(String(durationInMonths / 12), 10);
        months = parseInt(String(durationInMonths % 12), 10);
      } else {
        months = durationInMonths;
      }

      if (years) {
        r = years + (years === 1 ? ' Year' : ' Years');
      }
      if (months) {
        r += (r ? ', ' : '') + (months + (months === 1 ? ' Month' : ' Months'));
      }
    }

    return r;
  }

  getDonationProps() {
    const params = new URLSearchParams(window.location.search);

    return {
      campaign: params.get('campaign'),
      appeal: params.get('appeal'),
      fund: params.get('fund'),
      text: params.get('text'),
    };
  }

  getUrlParameter(param) {
    const sPageURL = window.location.search.substring(1);
    const sURLVariables = sPageURL.split(/[&||?]/);
    let res;

    for (let i = 0; i < sURLVariables.length; i += 1) {
      const paramName = sURLVariables[i];
      const sParameterName = (paramName || '').split('=');

      if (sParameterName[0] === param) {
        res = sParameterName[1];
        break;
      }
    }

    return res;
  }

  encodeDate(date) {
    return new this.QueryStringBuilderFactory({
      props: {
        date: date,
      },
      fields: {
        optional: ['date'],
      },
    }).query;
  }

  getDonationParamsBuilder() {
    const qs = new this.QueryStringBuilderFactory({
      props: {
        campaign: this.getUrlParameter('campaign'),
        appeal: this.getUrlParameter('appeal'),
        fund: this.getUrlParameter('fund'),
        text: this.getUrlParameter('text'),
      },
      fields: {
        optional: ['campaign', 'appeal', 'fund', 'text'],
      },
    });

    return qs;
  }

  getDonationParams() {
    return this.getDonationParamsBuilder().properties;
  }

  addDonationParams() {
    return this.getDonationParamsBuilder().query;
  }

  appendDonationParams() {
    return this.addDonationParams().replace('?', '&');
  }

  serializeQueryParams(params) {
    return this.$httpParamSerializerJQLike(params);
  }

  /**
   * Parses a query string and decodes each param
   */
  parseQueryParams(queryString: string) {
    const parsed = this.parseQueryString(queryString);

    return Object.keys(parsed).reduce((result, key) => {
      result[key] = decodeURIComponent(parsed[key]);

      return result;
    }, {});
  }

  /**
   * Retrieve the value at a given path. Otherwise returns the provided default value
   */
  path(nestedObj: TODO, path: Array<string | number>, defaultValue: any) {
    const value = path.reduce((obj, key) => {
      return obj && obj[key] !== 'undefined' ? obj[key] : undefined;
    }, nestedObj);

    return value == null ? defaultValue : value;
  }

  /**
   * Returns donation params + whatever query params are passed.
   * Returns empty string if there are no query params.
   */
  getQueryString(queryParams: Record<string, unknown>) {
    const serializedParams = this.serializeQueryParams(queryParams);

    return serializedParams ? '?' + serializedParams : '';
  }

  normalizeRedirectUrl(redirectUrl: string) {
    const url = new URL(redirectUrl, window.location.origin);

    return url.pathname + url.search;
  }

  makeUrl(urlSegments: any[], queryParams: Record<string, unknown> = {}) {
    const segments = urlSegments.slice();

    // Strip query string if it already existed
    const lastIndex = segments.length - 1;
    const lastSegment = segments[lastIndex];

    const processedQueryParams = _.merge({}, queryParams, this.getDonationParams());

    for (const key in processedQueryParams) {
      if (processedQueryParams[key] === undefined) {
        delete processedQueryParams[key];
      }
    }

    /**
     * @link https://acmeticketing.atlassian.net/browse/APP-1317
     */
    if (processedQueryParams.ref) {
      processedQueryParams.ref = this.normalizeRedirectUrl(processedQueryParams.ref);
    }

    const queryString = this.getQueryString(processedQueryParams);

    segments[lastIndex] = lastSegment + queryString;

    return segments.filter(Boolean).join('/');
  }

  /**
   * A place to centralize `window.location.href` calls to provide an easier debugging experience
   */
  setHref(url: string) {
    window.location.href = url;
  }

  /**
   * Coerces a value to a boolean
   */
  coerceBooleanProperty(value: string | boolean | null | undefined) {
    return value != null && String(value) !== 'false';
  }

  /**
   * Plain old sort by prop for objects you can add to .sort
   *
   * @example
   * ```ts
   * arrayOfObjects.sort(HelpersService.sortByPropName('propName'))
   * ```
   */
  sortByPropName(prop: string, order: 'asc' | 'desc' = 'asc') {
    return (a: TODO, b: TODO) => {
      const aprop = a[prop];
      const bprop = b[prop];
      const result = aprop < bprop ? -1 : aprop > bprop ? 1 : 0;
      const sortOrder = order === 'asc' ? 1 : -1;

      return result * sortOrder;
    };
  }

  /**
   * Check for isCsr flag on window object
   */
  isCSR(tenantId) {
    let r = false;
    const CSRCookie: string | boolean = window.CONFIG.isCSR;

    if (CSRCookie && CSRCookie === true) {
      r = true;
    }

    return r;
  }
}

export const HelpersServiceModule = angular
  .module('acme.common.service.helpers', [
    uiRouter,
    QueryStringBuilderFactoryModule,
    LocalStorageServiceModule,
    BugsnagServiceModule,
  ])
  .run([
    '$rootScope',
    '$state',
    '$log',
    '$transitions',
    'LocalStorageService',
    'BugsnagService',
    function run(
      $rootScope: IRootScopeService,
      $state: StateService,
      $log: ILogService,
      $transitions: TransitionService,
      localStorageService: LocalStorageService,
      bugsnagService: BugsnagService
    ) {
      $transitions.onSuccess({}, (transition) => {
        const to = transition.to();
        const toParams = transition.params();
        const from = transition.from();
        const fromParams = transition.params('from');

        /**
         *  Emits angular events to external scripts
         *  Consumed by tenant scripts implementation
         *  This will enable every page view to trigger and allow
         *  specific state tracking by any tenant scripts
         *  Because it is a copy it will NOT allow
         *  direct reference access to objects
         */
        $(window).trigger(
          'Angular::State',
          angular.copy({
            event: 'Change::Success',
            to: to,
            toParams: toParams,
            from: from,
            fromParams: fromParams,
          })
        );

        const membershipId = toParams.membershipId;
        const membershipInfo = localStorageService.getItem<VerifiedMemberInfo>('membership');
        const baseMembershipId = membershipInfo?.member.membershipId;

        if (membershipId && baseMembershipId && String(membershipId) !== String(baseMembershipId)) {
          const error = new Error(
            `URL's membershipId "${membershipId}" is different from base member "${baseMembershipId}"`
          );
          const cart = localStorageService.getItem<TODO>(`cart-${$state.params.tenantId}`);

          if (membershipInfo) {
            membershipInfo.member = scrubMembership(membershipInfo.member);
            membershipInfo.verifiedMember = membershipInfo.verifiedMember
              ? scrubMembership(membershipInfo.verifiedMember)
              : undefined;
            membershipInfo.auxiliary = membershipInfo.auxiliary.map(scrubMembership);
            membershipInfo.other = membershipInfo.other.map(scrubMembership);
          }

          bugsnagService.notify(error, (event) => {
            event.severity = 'info';
            event.context = 'verified-membership';
            event.addMetadata('memberships', {
              membershipId,
              membershipInfo,
              cart,
            });
          });
        }
      });
    },
  ])
  .service('HelpersService', HelpersService).name;
